import { ActiveBundlePageTypeKeys } from '@/store';
import { ServerBundleType } from './types';

export const BUNDLE_TAG = 'Bundle';
export const BUNDLE_FILTER_OPTIONS_TAG = 'BundleFilterOptions';
export const BUNDLE_SEARCH_TAG = 'BundleSearch';
export const BUNDLE_SECTIONS_TAG = 'BundleSections';
export const BUNDLE_SECTIONS_SUGGESTIONS_CATEGORY_LIST_TAG = 'BundleSectionsSuggestionsCategoryList';
export const BUNDLE_SECTIONS_SUGGESTIONS_SUB_CATEGORY_LIST_TAG = 'BundleSectionsSuggestionsSubCategoryList';
export const BUNDLE_PAGE_FIND_MISSING_TAG = 'BundlePageFindMissing';
export const BUNDLE_UNDO_REDO_HISTORY_TAG = 'BundleUndoRedoHistory';
export const BUNDLE_CATEGORY_LIST_TAG = 'BundleCategoryList';
export const BUNDLE_GET_DOWNLOAD_TAG = 'BundleGetDownload';

export const CASE_METADATA_TAG = 'CaseMetadata';
export const CASE_DOCUMENTS_TAG = 'CaseDocuments';
export const CASE_OVERVIEW_TAG = 'CaseOverview';
export const CASE_PROVIDERS_TAG = 'CaseProviders';
export const CASE_STATUS_TAG = 'CaseStatus';

export const CASES_TAG = 'Cases';
export const CASES_FILTERS_TAG = 'CasesFilters';
export const CASES_BASIC_TAG = 'CasesBasic';

export const MEDICAL_RECORDS_TAG = 'MedicalRecords';
export const MEDICAL_RECORDS_FILTERS_TAG = 'MedicalRecordsFilters';

export const TIMELINE_TAG = 'Timeline';
export const TIMELINE_UNDO_REDO_HISTORY_TAG = 'TimelineUndoRedoHistory';
export const CHRONOLOGY_TAG = 'Chronology';
export const CHRONOLOGY_UNDO_REDO_HISTORY_TAG = 'ChronologyUndoRedoHistory';

export const USERS_LIST_TAG = 'UsersList';
export const ACTIVE_USERS_LIST_TAG = 'ActiveUsersList';
export const DEACTIVATED_USERS_LIST_TAG = 'DeactivatedUsersList';
export const USER_ABOUT_TAG = 'UserAbout';

export const GDPR_DOCUMENT_TAG = 'GdprDocument';
export const GDPR_SUMMARY_TAG = 'GdprSummary';

export const MEDICAL_MATCH_TAG = 'MedicalMatch';
export const MEDICAL_MATCH_CAN_RERUN_TAG = 'MedicalMatchCanRerun';
export const MEDICAL_MATCH_LIVE_PROCESSING_TAG = 'MedicalMatchLiveProcessing';
export const MEDICAL_MATCH_LIVE_STATUS_TAG = 'MedicalMatchLiveStatus';

export const TEMPLATE_LIST_TAG = 'TemplateList';

/**
 * TAG GROUPS
 */
export const BUNDLE_DUPLICATES_TAG = 'BundleDuplicates';
export const BUNDLE_SIMILARS_TAG = 'BundleSimilars';
export const BUNDLE_TAGS = [
  BUNDLE_FILTER_OPTIONS_TAG,
  BUNDLE_SEARCH_TAG,
  BUNDLE_SECTIONS_SUGGESTIONS_CATEGORY_LIST_TAG,
  BUNDLE_SECTIONS_SUGGESTIONS_SUB_CATEGORY_LIST_TAG,
  BUNDLE_SECTIONS_TAG,
  BUNDLE_TAG,
  BUNDLE_PAGE_FIND_MISSING_TAG,
  BUNDLE_UNDO_REDO_HISTORY_TAG,
  BUNDLE_DUPLICATES_TAG,
  BUNDLE_SIMILARS_TAG,
  BUNDLE_CATEGORY_LIST_TAG,
  BUNDLE_GET_DOWNLOAD_TAG,
] as const;

export const CASE_TAGS = [
  CASE_METADATA_TAG,
  CASE_DOCUMENTS_TAG,
  CASE_OVERVIEW_TAG,
  CASE_PROVIDERS_TAG,
  CASE_STATUS_TAG,
] as const;

export const CASES_TAGS = [CASES_TAG, CASES_FILTERS_TAG, CASES_BASIC_TAG] as const;

export const MEDICAL_RECORDS_TAGS = [MEDICAL_RECORDS_TAG, MEDICAL_RECORDS_FILTERS_TAG] as const;

export const TIMELINE_CHRONOLOGY_TAGS = [
  TIMELINE_TAG,
  TIMELINE_UNDO_REDO_HISTORY_TAG,
  CHRONOLOGY_TAG,
  CHRONOLOGY_UNDO_REDO_HISTORY_TAG,
] as const;

export const USERS_TAGS = [USERS_LIST_TAG, ACTIVE_USERS_LIST_TAG, DEACTIVATED_USERS_LIST_TAG, USER_ABOUT_TAG] as const;

export const GDPR_TAGS = [GDPR_DOCUMENT_TAG, GDPR_SUMMARY_TAG] as const;

export const MEDICAL_MATCH_TAGS = [
  MEDICAL_MATCH_TAG,
  MEDICAL_MATCH_CAN_RERUN_TAG,
  MEDICAL_MATCH_LIVE_PROCESSING_TAG,
  MEDICAL_MATCH_LIVE_STATUS_TAG,
] as const;

export const TEMPLATE_TAGS = [TEMPLATE_LIST_TAG] as const;

export type ApiTagType = (
  | typeof BUNDLE_TAGS
  | typeof CASE_TAGS
  | typeof CASES_TAGS
  | typeof MEDICAL_RECORDS_TAGS
  | typeof MEDICAL_MATCH_TAGS
  | typeof TIMELINE_CHRONOLOGY_TAGS
  | typeof USERS_TAGS
  | typeof GDPR_TAGS
  | typeof TEMPLATE_TAGS
)[number];

/**
 * MAPPINGS
 */

export const bundleTypeMap: Record<ActiveBundlePageTypeKeys, ServerBundleType> = {
  light: 'LIGHT',
  full: 'FULL',
};
